import React, { Component } from 'react';
import { connect } from 'react-redux';
import './new-dashboard.scss';
import { TabContent, TabPane, Nav, NavItem, NavLink, BreadcrumbItem, Breadcrumb } from 'reactstrap';
import classnames from 'classnames';
import { Preloading } from '../../components/UI/Preloader/action';
import CreditWorthinessScoreTabContent from './Payment-Score-tabcontent/index';
import Report from './report/index';
import { PAYMENT_SCORE, CUG_SCORE, RISK_SCORE, PAYEMNT_VALUES_DEFAULT } from './constants';
import { fetchPaymentScore, getAllSections,showSectionPdf,fetchReportDetails, fetchCugScore, fetchPaymentRiskgrade, dataCheck, fetchReportListRequest,downloadReportPdf,dowloadAllcomputedSection,updateBPRStatus } from './action';
import { viewPublishedReport } from '../../Analyst/Cases/View/action';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { copyArray, formatInitialPaymentValues } from './helper';
import { setPageView } from '../../components/GoogleAnalytics/index';
import * as CaseViewActions from "../../Analyst/Cases/View/action";
import * as caseCreateAction from '../../Analyst/Cases/Create/actions';
import * as StringConst from '../../constants'
import fileSaver from 'file-saver';
class CreditWorthinessDashboard extends Component {
    constructor() {
        super();
        this.state = {
            activeTab: 'risk-score',
            activeVerticalTab: 'v-tab-1',
            creditScoreData: [],
            creditValueData: PAYEMNT_VALUES_DEFAULT,
            disableCorporateTab: true,
            disableCugTab: true,
            sectionListData:[],
            caseId:null,
            hideRiskMeter:false,
        }
    }

    componentDidMount() {
        setPageView('/Corporate/Report', document.location.href)
        this.props.getAllSections(this.props.match.params.id);
        this.props.preloading(true);
        this.props.fetchReportDetails(this.props.match.params.id);
        const tempRequestBody = {
            counterpartyId: this.props.match.params.counterPartyId,
            counterpartyType: this.props.match.params.counterPartyType
        }
        this.props.dataCheck(tempRequestBody);
        this.props.fetchReportListRequest(tempRequestBody);
    }
    componentDidUpdate(prevProps) {
        const { dataCheckFlag, dataCheckFlagFailure, counterPartyReportDetails, scoreData, scoreDataFailure, riskGradeFailure, sectionListResponse, allComputedSections, allComputedSectionsError,bprStatusSuccess,bprStatusFailure,result,createCaseFailure, counterPartyReportDetailsFailure} = this.props;
        if (dataCheckFlag !== prevProps.dataCheckFlag) {
            this.setState({
                disableCorporateTab: (dataCheckFlag.corporateDataExists) ? false : true,
                disableCugTab: (dataCheckFlag.cugDataExists) ? false : true,
            });
        }
        if (dataCheckFlagFailure !== prevProps.dataCheckFlagFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{dataCheckFlagFailure.data.message}
                </div>
            );
        }
        if (counterPartyReportDetails !== prevProps.counterPartyReportDetails) {
            this.props.viewPublishedReport(counterPartyReportDetails.computedReportId);
            this.setState({
                hideRiskMeter:false,
                });
        }
        if(counterPartyReportDetailsFailure !== prevProps.counterPartyReportDetailsFailure){
            this.setState({
            hideRiskMeter:true,
            });
        }
        if (scoreData !== prevProps.scoreData) {
            const tempLevelOne = copyArray(scoreData.levelOneKeyFields)
            const tempLevelTwo = copyArray(scoreData.levelTwoKeyFields)
            let tempFormattedValue = formatInitialPaymentValues((tempLevelOne).concat(tempLevelTwo), scoreData)
            this.setState({
                creditScoreData: scoreData,
                creditValueData: tempFormattedValue
            })
            this.props.fetchPaymentRiskgrade();
        }
        if (scoreDataFailure !== prevProps.scoreDataFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{scoreDataFailure.data.message}
                </div>
            );
        }
        if (riskGradeFailure !== prevProps.riskGradeFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{riskGradeFailure.data.message}
                </div>
            );
        }
        if (sectionListResponse !== prevProps.sectionListResponse) {
            this.setState({
                sectionListData: sectionListResponse
            })
            if(sectionListResponse.data.length > 0){
                this.props.preloading(false);
            }
        }
        if (allComputedSections !== prevProps.allComputedSections) {
            window.open(allComputedSections.data);
            toast.success(
                  <div>
                       <i className="fa fa-check"></i>&nbsp; Excel has been downloaded sucessfully
                      </div>
                        )
            
          }
          if(allComputedSectionsError && allComputedSectionsError !==prevProps.allComputedSectionsError)
          {
            let errorMessage="";
            if(allComputedSectionsError.status && allComputedSectionsError.status== 400 && allComputedSectionsError.data &&allComputedSectionsError.data.message){
                errorMessage=allComputedSectionsError.data.message
            }
            else{
                errorMessage="failed to fetch file"
            }
            toast.warn(
                <div>
                     <i className="fa fa-exclamation-triangle"></i>&nbsp; {errorMessage}
                    </div>
                      )
          }
          if (bprStatusSuccess !== prevProps.bprStatusSuccess) {
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp; BPR Refresh request placed successfully ....!
                </div>
            );
            window.location.reload()
        }
        if (bprStatusFailure !== prevProps.bprStatusFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp; BPR Refresh request failed ....!
                </div>
            );
        }if (createCaseFailure !== prevProps.createCaseFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp; Refresh Case Creation failed please contact Rubix team ....!
                </div>
            );
        }
        if (!this.props.result.error && this.props.result !== prevProps.result) {
            this.props.updateBPRStatus(this.state.caseId)
        }
        if (this.props.result.error && this.props.result !== prevProps.result) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp; Refresh Case Creation failed please contact Rubix team ....!
                </div>
            );
            this.props.preloading(false);
        }
        
    }

    toggleDashboardTabs = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
            switch (tab) {
                case PAYMENT_SCORE:
                    setPageView('/Corporate/PaymentScore', document.location.href)
                    this.props.fetchPaymentScore(this.props.match.params.counterPartyId);
                    break;
                case CUG_SCORE:
                    setPageView('/Corporate/CUGScore', document.location.href);
                    const tempRequestBody = {
                        counterpartyId: this.props.match.params.counterPartyId,
                        counterpartyType: this.props.match.params.counterPartyType
                    }
                    this.props.fetchCugScore(tempRequestBody);
                    break;
                case RISK_SCORE:
                    setPageView('/Corporate/Report', document.location.href)
                    this.props.fetchReportDetails(this.props.match.params.id);
                    break;
                // default: ''
            }
        }
    }

    renderDashboardTabs = () => {
        return (
            <Nav tabs className="mb-5">
                <NavItem className="pr-2 text-center">
                    <NavLink
                        className={classnames({ active: this.state.activeTab === RISK_SCORE })}
                        onClick={() => { this.toggleDashboardTabs(RISK_SCORE); }}
                    >
                        Risk Score
                    </NavLink>
                </NavItem>
                <NavItem className="pr-2 text-center">
                    <NavLink
                        className={classnames({ active: this.state.activeTab === PAYMENT_SCORE })}
                        onClick={() => { this.toggleDashboardTabs(PAYMENT_SCORE); }}
                        disabled={this.state.disableCorporateTab}
                    >
                        Payment Score
                    </NavLink>
                </NavItem>
                <NavItem className="pr-2 text-center">
                    <NavLink
                        className={classnames({ active: this.state.activeTab === CUG_SCORE })}
                        onClick={() => { this.toggleDashboardTabs(CUG_SCORE); }}
                        disabled={this.state.disableCugTab}
                    >
                        CUG Score
                    </NavLink>
                </NavItem>
            </Nav>
        )
    }

    showSectionPdf =(surveyPdfFile)=>{
     this.props.showSectionPdf(surveyPdfFile)
    }

    downloadFinalReport=(e)=>{
        e.preventDefault();
        if(this.props.counterPartyReportDetails.companyName == null || this.props.counterPartyReportDetails.companyName == "undefined"){
            this.props.downloadReportPdf(this.props.match.params.id,this.props.reportListResponse.data[0].counterpartyName);    
        }else{
            this.props.downloadReportPdf(this.props.match.params.id,this.props.counterPartyReportDetails.companyName);
        }
        
    }

    dowloadAllcomputedSection = (event) =>{
        event.preventDefault();
        this.props.getAllComputedSectionTemplate(this.props.match.params.id)
      }
    placeRefreshReport = (data) =>{
        this.case = {
            "productId": data.productId,
            "corporateId": data.corporateId,
            "corporateName": data.corporateName,
            "counterpartyId":data.counterpartyId,
            "counterpartyType": data.counterpartyType,
            "zoneId": (data.caseType === StringConst.DOMESTIC) ?  data.zoneId: null,
            "caseType": data.caseType,
            "requestType":"CLIENT_PORTAL",
            "requestedById":data.requestedById,
            "bprCheck":true,
        }
        this.props.preloading(true);
        this.setState({caseId:data.caseId});
        this.props.createCase(this.case);
      }

    render() {
        return (
            <div className="p-3 flex-grow-1">
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to="/my-portfolio/1">Case Portfolio</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Report</BreadcrumbItem>
                </Breadcrumb>
                {this.renderDashboardTabs()}
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={RISK_SCORE}>
                        <Report {...this.props} hideRiskMeter={this.state.hideRiskMeter} getAllSections={this.state.sectionListData} showSectionPdf={this.showSectionPdf} downloadFinalReport={this.downloadFinalReport} sectionPdf={this.props.sectionPdf} dowloadAllcomputedSection={this.dowloadAllcomputedSection} placeRefreshReport = {this.placeRefreshReport} />
                    </TabPane>
                    <TabPane tabId={PAYMENT_SCORE}>
                        <CreditWorthinessScoreTabContent id={PAYMENT_SCORE} paymentValueData={this.state.creditValueData} paymentData={this.state.creditScoreData} riskGrade={this.props.riskGrade} />
                    </TabPane>
                    {/* {this.renderPaymentScoreTabContent()} */}
                    <TabPane tabId={CUG_SCORE}>
                        <CreditWorthinessScoreTabContent id={CUG_SCORE} paymentValueData={this.state.creditValueData} paymentData={this.state.creditScoreData} riskGrade={this.props.riskGrade} />
                    </TabPane>
                </TabContent>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    counterPartyReportDetails: state.reportCorporate.reportDetails,
    counterPartyReportDetailsFailure:state.reportCorporate.reportDetailsFailure, 
    sectionPdf: state.reportCorporate.sectionPdf,
    fetchPdf: state.section.viewCompletedReportPdf,
    scoreData: state.reportCorporate.scoreData,
    scoreDataFailure: state.reportCorporate.scoreDataFailure,
    riskGrade: state.reportCorporate.riskGradeData,
    riskGradeFailure: state.reportCorporate.riskGradeDataFailure,
    dataCheckFlag: state.reportCorporate.dataCheck,
    dataCheckFlagFailure: state.reportCorporate.dataCheckFailure,
    reportListResponse: state.reportCorporate.reportListResponse,
    sectionListResponse: state.reportCorporate.sectionListResponse,
    allComputedSections: state.section.allComputedSections,
    allComputedSectionsError: state.section.allComputedSectionsError,
    bprStatusSuccess: state.reportCorporate.bprStatusSuccess,
    bprStatusFailure: state.reportCorporate.bprStatusFailure,
    createCaseFailure:state.createCase.createCaseFailure,
    result: state.createCase.result,
    selectedCompanyName: state.portfolio.setSelectedCompanyName
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    showSectionPdf: (id) => { dispatch(showSectionPdf(id)) },
    downloadReportPdf: (id,name) => { dispatch(downloadReportPdf(id,name)) },
    getAllSections: (id) => { dispatch(getAllSections(id)) },
    fetchReportDetails: (id) => { dispatch(fetchReportDetails(id)) },
    viewPublishedReport: (id) => { dispatch(viewPublishedReport(id)) },
    fetchPaymentScore: (id) => { dispatch(fetchPaymentScore(id)) },
    fetchCugScore: (id) => { dispatch(fetchCugScore(id)) },
    fetchPaymentRiskgrade: () => { dispatch(fetchPaymentRiskgrade()) },
    dataCheck: (id) => { dispatch(dataCheck(id)) },
    fetchReportListRequest: (id) => { dispatch(fetchReportListRequest(id)) },
    getAllComputedSectionTemplate: id =>{dispatch(CaseViewActions.getAllComputedSectionTemplate(id))},
    createCase: (data) => { dispatch(caseCreateAction.createCase(data)); },
    updateBPRStatus: (id) => { dispatch(updateBPRStatus(id)); },
});
export default CreditWorthinessDashboard = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditWorthinessDashboard)
